/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

class CheckBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.checked
    };
    this.toggleCheckboxChange = this.toggleCheckboxChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isChecked: nextProps.checked });
  }

  toggleCheckboxChange() {
    const { handleCheckboxChange, value } = this.props;

    this.setState(
      prevState => ({ isChecked: !prevState.isChecked }),
      () => handleCheckboxChange(value, this.state.isChecked)
    );
  }

  render() {
    const { label, value } = this.props;
    const { isChecked } = this.state;

    return (
      <label className="checkbox-label">
        <input
          type="checkbox"
          value={value}
          checked={isChecked}
          onChange={this.toggleCheckboxChange}
        />
        <span>{label}</span>
      </label>
    );
  }
}

CheckBox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired
};

export default CheckBox;
